// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".KxKi1KW8{--cols:4;grid-column-gap:2.5rem;grid-row-gap:2.5rem;-moz-column-gap:2.5rem;column-gap:2.5rem;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));grid-template-columns:repeat(var(--cols),minmax(0,1fr));margin-bottom:max(1.69rem,min(2.5vw,3rem));padding-top:3.94rem;row-gap:2.5rem}@media(max-width:1365.98px){.KxKi1KW8{--cols:3}}@media(max-width:991.98px){.KxKi1KW8{--cols:2;-moz-column-gap:1.56rem;column-gap:1.56rem;row-gap:1.56rem}}@media(max-width:575.98px){.KxKi1KW8{--cols:1}}._6XbyDYKy{margin-bottom:max(.84rem,min(1.25vw,1.5rem))}.ZJAC3mUR{color:inherit;font-size:1rem;letter-spacing:-.05em;line-height:1.39}@media(max-width:767.98px){.ZJAC3mUR{font-size:1rem}}.BJRuctnO{display:block;font-size:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"items": "KxKi1KW8",
	"address": "_6XbyDYKy",
	"email": "ZJAC3mUR",
	"tel": "BJRuctnO"
};
module.exports = ___CSS_LOADER_EXPORT___;
